import React from "react";
import "./ServiceGreenBanner.css";
import { FormattedMessage } from "react-intl";

export default function Index({ leftText, rightText }) {
    return (
      <div className="green_banner_wrapper">
        <div className="green_banner">
          <div className="text_container">
            <div className="title_container">
                <h2 className="title"><FormattedMessage id={leftText} /></h2>
            </div>
            <div className="paragraph_container">
                <p className="paragraph"><FormattedMessage id={rightText} /></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  